import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "bg-white p-3 my-3 border-round-sm text-sm"
}

import { computed, ref, toRefs, watch } from 'vue';
import Sidebar from 'primevue/sidebar';
import { useCalendarStore } from '@/store';
import { PastDocumentationCard } from './index';
import { Attendee } from '@/types';
import VirtualScroller from 'primevue/virtualscroller';

interface Props {
  open: boolean;
  student?: Attendee;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PastDocumentations',
  props: {
    open: { type: Boolean },
    student: {}
  },
  emits: ['closePastDocumentations', 'loadStudentPastSessions'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const calendarStore = useCalendarStore();
const { open, student } = toRefs(props);
const openDialog = ref(false);
const emit = __emit;

const studentPastDocumentations = computed(() => {
  const data = calendarStore.pastDocumentations.filter((result) => result.attendee_id === student.value.id);

  if (data.length > 0) {
    calendarStore.updatePastDocumentationState(student.value.id, data[data.length - 1].event.start_at);
  }

  return data;
});

const emitClose = () => {
  emit('closePastDocumentations');
};

watch(open, () => {
  openDialog.value = open.value;
});

const onLazyLoad = (event) => {
  if (event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight) {
    emit('loadStudentPastSessions');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_unref(Sidebar), {
    visible: openDialog.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((openDialog).value = $event)),
    class: "past-documentation-sidebar",
    position: "right",
    modal: false,
    onHide: emitClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[1] || (_cache[1] = _createTextVNode(" Past Sessions ", -1)),
        _createElementVNode("span", null, "- " + _toDisplayString(_unref(student)?.full_name), 1)
      ]),
      (studentPastDocumentations.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(VirtualScroller), {
            key: 0,
            class: "custom-loading",
            items: studentPastDocumentations.value,
            "item-size": 1,
            delay: 250,
            "scroll-height": "calc(100vh - 53.5px)",
            onScroll: onLazyLoad
          }, {
            content: _withCtx(({ items }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                return (_openBlock(), _createBlock(_unref(PastDocumentationCard), {
                  key: item.result.id,
                  data: item
                }, null, 8, ["data"]))
              }), 128)),
              (_unref(calendarStore).pastDocumentationsLoading)
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    width: "100%",
                    height: "1.5rem"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items"]))
        : _createCommentVNode("", true),
      (studentPastDocumentations.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("p", null, "No past sessions to display.", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})